export default {
  SET_AUDITS(state, payload) {
    state.audits = payload;
  },
  SET_PAGINATION: (state, payload) => {
    state.pagination = payload;
  },
};
